export const BASE_URL = 'https://learnaihub.net/learnai-api';
export const UPLOAD_BASE_URL = 'https://learnaihub.net/assets';

async function request<T>(endpoint: string, options: RequestInit): Promise<T> {
    const headers = {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
    };

    const response = await fetch(`${BASE_URL}${endpoint}`, {
        ...options,
        headers,
    });

    let data: any = null;
    try {
        data = await response.json();
    } catch {
        data = null;
    }

    if (!response.ok) {
        throw new Error(data?.message || 'Something went wrong');
    }

    return data as T;
}

export const api = {
    post: <T>(endpoint: string, body: unknown, options: Omit<RequestInit, 'method' | 'body'> = {}): Promise<T> =>
        request<T>(endpoint, { method: 'POST', body: JSON.stringify(body), ...options }),

    put: <T>(endpoint: string, body: unknown, options: Omit<RequestInit, 'method' | 'body'> = {}): Promise<T> =>
        request<T>(endpoint, { method: 'PUT', body: JSON.stringify(body), ...options }),

    get: <T>(endpoint: string, options: Omit<RequestInit, 'method'> = {}): Promise<T> =>
        request<T>(endpoint, { method: 'GET', ...options }),
};
